<template>
  <v-flex d-block xs12>
    <v-card>
      <v-card-title>
        <h3 style="display: inline-block;">Clients services</h3>
        <v-spacer/>
      </v-card-title>
      <v-card-text>
      <div class="sticky-block">
        <v-layout row>
          <v-flex xs6>
            <v-switch
              label="Show services with clients"
              v-model="showServicesWithClients"
              class="ml-3"
            />
          </v-flex>
          <v-flex xs6 text-xs-right>
            <v-btn
              color="success"
              @click="handleClickCreateServiceEvent"
            >Create service</v-btn>
          </v-flex>
        </v-layout>
        <v-flex xs6>
          <clients-select v-model="selectedClients"/>
        </v-flex>
      </div>
      <table class="v-table theme--light">
        <thead>
        <tr>
          <th class="column text-xs-left">Service</th>
          <th class="column text-xs-left">Code</th>
          <th class="column text-xs-left">BasePrice</th>
          <th class="column text-xs-left" v-for="id in selectedClients" v-bind:key="id">
            {{ availableClientsById[id].title }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="service in visibleServices" v-bind:key="service.id">
          <td>{{ service.title }}</td>
          <td>{{ service.code }}</td>
          <td>{{ service.price | currency }}</td>
          <td v-for="clientId in selectedClients" v-bind:key="clientId">
            <client-service-price @createdClientService="handleCreatedClientServiceEvent" @updatedClientService="handleUpdatedClientServiceEvent" :item="getServicesByClients(service.id, clientId)"/>
          </td>
        </tr>
        </tbody>
      </table>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import ClientServicePrice from './ClientServicePrice'
import ClientsSelect from '../Ui/mcc/ClientsSelect'
import _ from 'lodash'

export default {
  name: 'client-service-prices',
  props: {
    availableClients: {
      type: Array
    },
    availableServices: {
      type: Array
    },
    servicesByClients: {
      type: Object
    }
  },
  components: {
    ClientServicePrice,
    ClientsSelect
  },
  data() {
    return {
      selectedClients: [],
      showServicesWithClients: true
    }
  },
  computed: {
    availableClientsById: function() {
      return _.keyBy(this.availableClients, 'id')
    },
    availableServicesById: function() {
      return _.keyBy(this.availableServices, 'id')
    },
    visibleServices() {
      let result = this.availableServices
      if (this.showServicesWithClients === true) {
        result = _.filter(this.availableServices, (v) => _.indexOf(_.keys(this.servicesByClients), v.id) !== -1)
      }

      return _.sortBy(result, 'code')
    }
  },
  methods: {
    getServicesByClients(serviceId, clientId) {
      let existingServiceClients = this.servicesByClients[serviceId] || null
      let service = this.availableServicesById[serviceId] || null
      if (service === null) {
        throw new Error('Unable to find service by id')
      }

      let emptyClientService = {
        clientId: clientId,
        serviceId: serviceId,
        price: null,
        currency: service.currency,
        defaultPrice: service.price,
        hidden: false
      }

      if (existingServiceClients == null) {
        return emptyClientService
      }

      let existingClientService = existingServiceClients[clientId] || null

      if (existingClientService == null) {
        return emptyClientService
      }

      return existingClientService
    },
    handleCreatedClientServiceEvent(createdClientService) {
      this.$emit('createdClientService', createdClientService)
    },
    handleUpdatedClientServiceEvent(updatedClientService) {
      this.$emit('updatedClientService', updatedClientService)
    },
    handleClickCreateServiceEvent() {
      this.$emit('handleClickCreateService')
    }
  }
}
</script>

<style scoped>
  .sticky-block {
    position: sticky;
    top: 50px;
    padding-top: 5px;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sales/ClientServicePrices.vue